import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'PostCard' })({
    root: {
        display: 'flex',
        padding: 40,
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 16,
        borderRadius: 24,
        background: 'rgba(0, 0, 0, 0.15)',
        textDecoration: 'none'
    },
    published: {
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px'
    },
    tags: {
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: 8
    },
    tag: {
        display: 'flex',
        padding: '8px 12px',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        borderRadius: 100,
        background: 'rgba(255, 255, 255, 0.05)'
    }
});
